import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export async function getCareerList(config) {
    return httpUtils.get(`${env.API_VERSION}/career`, config);
}

export async function getCareerDetail(uuid, config) {
    return httpUtils.get(`${env.API_VERSION}/career/${uuid}`, config);
}

export async function getCareerOther(uuid, config) {
    return httpUtils.get(`${env.API_VERSION}/career/${uuid}/other`, config);
}

export async function applyCareer(config) {
    return httpUtils.post(`${env.API_VERSION}/job-apply`, config);
}

export async function upload(config) {
    return httpUtils.post(`${env.API_VERSION}/upload`, config);
}